<template>
  <!-- Historique projet -->
  <div class="onlyDisplayedifSectionIsActive" :class="{ activeSection: section == 'historique' }">
    <div class="container">
      <div v-if="!readonly || !isPorteurProjet" class="projet-part main-content">
        <div class="first">
          <ProjetHistoryView
            :role="role"
            :projet-annuel="project"
            :is-porteur-projet="isPorteurProjet"
          ></ProjetHistoryView>
        </div>
        <div class="second">
          <LabellisationRecap
            v-if="!readonly || !isPorteurProjet"
            :readonly="readonly || !isPorteurProjet"
            :projet-annuel="project"
            :projet-validation="lastProjectValidation"
            :validation-activated="validationActivated"
            :show-validation-errors="showValidationErrors"
            :section-to-anchors="anchorsToTrack"
            :sections-to-icon="sectionsToIcon"
            :renewal-suffix="renewalSuffix"
            :is-porteur-projet="isPorteurProjet"
            @trigger-validation="$emit('trigger-validation')"
            @toggle-validation="$emit('toggle-validation')"
          />
        </div>
      </div>
      <div v-else>
        <ProjetHistoryView
          :role="role"
          :projet-annuel="project"
          :is-porteur-projet="isPorteurProjet"
        ></ProjetHistoryView>
      </div>
    </div>
  </div>

  <!-- En bref -->
  <div class="onlyDisplayedifSectionIsActive" :class="{ activeSection: section == 'bref' }">
    <div class="projet-part">
      <EnBrefView
        :projet-annuel="project"
        :readonly="readonly"
        :is-porteur-projet="isPorteurProjet"
        :validation-activated="validationActivated"
        :show-validation-errors="showValidationErrors"
        :section="section"
        :map-screen-shot-requested="mapScreenShotRequested"
        @projet-annuel-updated="updateProjetAnnuel"
        @trigger-validation="$emit('trigger-validation')"
        @map-screenshot-done="mapScreenshotDone"
        @images-url-changed="(imagesUrl) => $emit('images-url-changed', imagesUrl)"
      ></EnBrefView>
    </div>
  </div>

  <!-- Mon année -->
  <div
    class="onlyDisplayedifSectionIsActive pdf-page-break"
    :class="{ activeSection: section == 'mon-annee' }"
  >
    <ConseilsDesElevesView
      :projet-annuel="project"
      :readonly="readonly"
      :is-porteur-projet="isPorteurProjet"
      :validation-activated="validationActivated"
      :show-validation-errors="showValidationErrors"
      @projet-annuel-updated="updateProjetAnnuel"
      @dirtify-project="$emit('dirtify-project')"
      @trigger-validation="$emit('trigger-validation')"
    ></ConseilsDesElevesView>

    <EtatDesLieuxView
      :projet-annuel="project"
      :readonly="readonly"
      :section="section"
      :is-porteur-projet="isPorteurProjet"
      :validation-activated="validationActivated"
      :show-validation-errors="showValidationErrors"
      :current-width="currentWidth"
      :current-scroll-y="currentScrollY"
      @projet-annuel-updated="updateProjetAnnuel"
      @dirtify-project="$emit('dirtify-project')"
      @trigger-validation="$emit('trigger-validation')"
    />

    <ProblematiquesOrientationsActionsView
      :projet-annuel="project"
      :readonly="readonly"
      :is-porteur-projet="isPorteurProjet"
      :validation-activated="validationActivated"
      :show-validation-errors="showValidationErrors"
      @projet-annuel-updated="updateProjetAnnuel"
      @dirtify-project="$emit('dirtify-project')"
      @trigger-validation="$emit('trigger-validation')"
    />

    <ProjetDiffusionView
      :projet-annuel="project"
      :readonly="readonly"
      :is-porteur-projet="isPorteurProjet"
      :validation-activated="validationActivated"
      :show-validation-errors="showValidationErrors"
      @projet-annuel-updated="updateProjetAnnuel"
      @dirtify-project="$emit('dirtify-project', $event)"
      @trigger-validation="$emit('trigger-validation')"
    />

    <AutresInfosView
      :validation-activated="validationActivated"
      :show-validation-errors="showValidationErrors"
      :projet-annuel="project"
      :readonly="readonly"
      :is-porteur-projet="isPorteurProjet"
      @projet-annuel-updated="updateProjetAnnuel"
      @projet-updated="updateProjetAnnuel"
      @dirtify-project="$emit('dirtify-project')"
      @trigger-validation="$emit('trigger-validation')"
    />
  </div>

  <!-- Infos administratives -->
  <div
    class="onlyDisplayedifSectionIsActive pdf-page-break"
    :class="{ activeSection: section == 'infos_administratives' }"
  >
    <ProjetCharteView
      :validation-activated="validationActivated"
      :show-validation-errors="showValidationErrors"
      :projet-annuel="project"
      :readonly="readonly"
      @projet-annuel-updated="updateProjetAnnuel"
      @trigger-validation="$emit('trigger-validation')"
      @dirtify-project="$emit('dirtify-project')"
    />

    <ProjetParticipants
      :validation-activated="validationActivated"
      :show-validation-errors="showValidationErrors"
      :projet-annuel="project"
      :readonly="readonly"
      :is-porteur-projet="isPorteurProjet"
      @projet-annuel-updated="updateProjetAnnuel"
      @dirtify-project="$emit('dirtify-project', $event)"
      @trigger-validation="$emit('trigger-validation')"
    />

    <ProjetFinancementView
      :validation-activated="validationActivated"
      :show-validation-errors="showValidationErrors"
      :projet-annuel="project"
      :readonly="readonly || !isPorteurProjet"
      @projet-annuel-updated="updateProjetAnnuel"
      @dirtify-project="$emit('dirtify-project')"
      @trigger-validation="$emit('trigger-validation')"
    />

    <ProjetSiteView
      :validation-activated="validationActivated"
      :show-validation-errors="showValidationErrors"
      :projet-annuel="project"
      :readonly="readonly || !isPorteurProjet"
      @projet-annuel-updated="updateProjetAnnuel"
      @dirtify-project="$emit('dirtify-project')"
      @trigger-validation="$emit('trigger-validation')"
    />

    <div class="projet-part">
      <ProjetAutresInfosView
        :validation-activated="validationActivated"
        :show-validation-errors="showValidationErrors"
        :projet-annuel="project"
        :readonly="readonly || !isPorteurProjet"
        @projet-annuel-updated="updateProjetAnnuel"
        @dirtify-project="$emit('dirtify-project')"
      />
    </div>
  </div>

  <!-- Labellisation -->
  <div
    class="onlyDisplayedifSectionIsActive pdf-page-break"
    :class="{ activeSection: section == 'labellise' }"
  >
    <LabellisationResult
      v-if="project.statut !== 'BROUILLON'"
      :projet-annuel="project"
      :renewal-suffix="renewalSuffix"
    />
    <div v-if="project.typeDossier !== 'DOSSIER_RENOUVELLEMENT_LIGHT'"></div>
    <PlusView
      v-if="project.typeDossier !== 'DOSSIER_RENOUVELLEMENT_LIGHT'"
      :validation-activated="validationActivated"
      :show-validation-errors="showValidationErrors"
      :projet-annuel="project"
      :read-only="readonly || !isPorteurProjet"
      @projet-annuel-updated="$emit('projet-annuel-updated', $event)"
      @dirtify-project="$emit('dirtify-project')"
      @trigger-validation="$emit('trigger-validation')"
    />
    <SuiviView
      :validation-activated="validationActivated"
      :show-validation-errors="showValidationErrors"
      :projet-annuel="project"
      :read-only="readonly || !isPorteurProjet"
      @projet-annuel-updated="$emit('projet-annuel-updated', $event)"
      @dirtify-project="$emit('dirtify-project')"
      @trigger-validation="$emit('trigger-validation')"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue"
import LabellisationRecap from "@/pages/projet-page/labellisation/LabellisationRecap.vue"
import LabellisationResult from "@/pages/projet-page/labellisation/LabellisationResult.vue"
import ProjetCharteView from "@/pages/projet-page/info-administratives/ProjetCharteView.vue"
import ProjetParticipants from "@/pages/projet-page/info-administratives/ProjetParticipants.vue"
import ProjetSiteView from "@/pages/projet-page/info-administratives/ProjetSiteView.vue"
import ProjetFinancementView from "@/pages/projet-page/info-administratives/ProjetFinancementView.vue"
import ProjetAutresInfosView from "@/pages/projet-page/info-administratives/ProjetAutresInfosView.vue"
import ProjetDiffusionView from "@/pages/projet-page/mon-annee/ProjetDiffusionView.vue"
import PlusView from "@/pages/projet-page/labellisation/PlusView.vue"
import SuiviView from "@/pages/projet-page/labellisation/SuiviView.vue"
import { ProjetAnnuelDTO, StatutDossier } from "@/model/bean/GeneratedDTOs"
import { ValidationStatus } from "@/model/ValidationResult"
import {
  BackToPreviousScreenItem,
  BulletWithValidation,
  ContextMenu,
  NavbarItem,
  NavbarItemWithoutLink,
} from "@/views/menus/MenuItems"
import EnBrefView from "@/pages/projet-page/en-bref/EnBrefView.vue"
import ProblematiquesOrientationsActionsView from "@/pages/projet-page/mon-annee/ProblematiquesOrientationsActionsView.vue"
import ConseilsDesElevesView from "@/pages/projet-page/mon-annee/ConseilsDesElevesView.vue"
import AutresInfosView from "@/pages/projet-page/mon-annee/AutresInfosView.vue"
import EtatDesLieuxView from "@/pages/projet-page/mon-annee/EtatDesLieuxView.vue"
import ProjetHistoryView from "@/pages/projet-page/history/ProjetHistoryView.vue"
import { eventBus } from "@/services/EventBus"

// Type local pour la validation (remplace l'import supprimé)
export class ProjetAnnualValidation {
  invalidFields = new Map<string, any[]>()
  emptyFields = new Map<string, any[]>()
}

export const PROJECT_SECTIONS = {
  HISTORY: "historique",
  EN_BREF: "bref",
  MY_YEAR: "mon-annee",
  ADMIN_INFOS: "infos_administratives",
  LABELISED: "labellise",
}

export default defineComponent({
  name: "ProjetLabellisationHolder",
  components: {
    EnBrefView,
    ProjetCharteView,
    ProjetParticipants,
    ProjetHistoryView,
    LabellisationRecap,
    LabellisationResult,
    ProjetSiteView,
    ProjetFinancementView,
    ProjetAutresInfosView,
    EtatDesLieuxView,
    ProblematiquesOrientationsActionsView,
    ConseilsDesElevesView,
    ProjetDiffusionView,
    PlusView,
    SuiviView,
    AutresInfosView,
  },
  props: {
    project: {
      type: Object as PropType<ProjetAnnuelDTO>,
      required: true,
    },
    role: {
      type: String,
      default: "",
    },
    section: {
      type: String,
      default: "history",
    },
    activeTab: {
      type: Number,
      default: 0,
    },
    lastProjectValidation: {
      type: Object as PropType<ProjetAnnualValidation>,
      default: null,
    },
    validationActivated: {
      type: Boolean,
      default: true,
    },
    showValidationErrors: {
      type: Boolean,
      default: true,
    },
    readonly: {
      type: Boolean,
      required: false,
    },
    isPorteurProjet: {
      type: Boolean,
      required: false,
    },
    currentWidth: {
      type: Number,
      default: 0,
    },
    currentScrollY: {
      type: Number,
      default: 0,
    },
    pxFromBottom: {
      type: Number,
      default: 0,
    },
    isMapScreenshotRequested: {
      type: Boolean,
      default: false,
    },
  },

  emits: [
    "trigger-validation",
    "toggle-validation",
    "images-url-changed",
    "dirtify-project",
    "projet-annuel-updated",
    "screenshot-ready",
  ],
  data() {
    return {
      anchorsToTrack: new Map<string, string[]>(),
      sectionsToIcon: new Map<string, string>(),
      //Hack to please linter
      statutDossier: "BROUILLON" as StatutDossier,
      // Indicates if projet has been validated at least once
      // (and hence lastProjectvalidationCanBeUsed to display last validation results)
      wasValidatedAtLeastOnce: false,
      renewalSuffix: "",
      mapScreenShotRequested: false,
    }
  },

  watch: {
    lastProjectValidation() {
      this.wasValidatedAtLeastOnce = true
      this.refreshContextMenu()
    },
    validationActivated() {
      this.refreshContextMenu()
    },
    currentScrollY() {
      this.refreshActiveAnchor()
    },
    section() {
      this.sectionChanged()
    },
    project() {
      this.setRenewalSuffix()
    },
    isMapScreenshotRequested() {
      if (this.isMapScreenshotRequested) {
        this.doMapScreenshot()
      }
    },
  },
  mounted(): void {
    this.setRenewalSuffix()
    this.refreshContextMenu()
  },
  methods: {
    refreshContextMenu(): void {
      const menuItems = []
      this.anchorsToTrack = new Map<string, string[]>()
      if (this.project) {
        menuItems.push(new BackToPreviousScreenItem())

        menuItems.push(new NavbarItemWithoutLink(this.project.nom, ""))

        menuItems.push(this.getMenuEntry(PROJECT_SECTIONS.HISTORY, "calendar", "0"))

        menuItems.push(this.getMenuEntry(PROJECT_SECTIONS.EN_BREF, "smile", "0"))

        // Mon année
        const myYearMenuEntry = this.getMenuEntry(
          PROJECT_SECTIONS.MY_YEAR,
          "calendar-alt",
          "0",
          !this.isPorteurProjet,
        )
        myYearMenuEntry.children = [
          this.getBulletEntry(PROJECT_SECTIONS.MY_YEAR, "conseil", false),
          this.getBulletEntry(PROJECT_SECTIONS.MY_YEAR, "etat", false),
          this.getBulletEntry(PROJECT_SECTIONS.MY_YEAR, "problematiques", false),
          this.getBulletEntry(PROJECT_SECTIONS.MY_YEAR, "diffusion", false),
          this.getBulletEntry(PROJECT_SECTIONS.MY_YEAR, "autre", false),
        ]
        menuItems.push(myYearMenuEntry)

        // Infos administrative
        const adminMenuEntry = this.getMenuEntry(PROJECT_SECTIONS.ADMIN_INFOS, "file", "0")
        adminMenuEntry.children = [
          this.getBulletEntry(PROJECT_SECTIONS.ADMIN_INFOS, "charte", false),
          this.getBulletEntry(PROJECT_SECTIONS.ADMIN_INFOS, "participants", false),
          this.getBulletEntry(PROJECT_SECTIONS.ADMIN_INFOS, "financements", false),
          this.getBulletEntry(PROJECT_SECTIONS.ADMIN_INFOS, "site", false),
          this.getBulletEntry(PROJECT_SECTIONS.ADMIN_INFOS, "autresinfos", false),
        ]
        menuItems.push(adminMenuEntry)

        // Labelisation
        const labeliseMenuEntry = this.getMenuEntry(
          PROJECT_SECTIONS.LABELISED,
          "check",
          "0",
          !this.isPorteurProjet,
        )
        labeliseMenuEntry.children = []

        if (this.project.typeDossier !== "DOSSIER_RENOUVELLEMENT_LIGHT") {
          labeliseMenuEntry.children.push(
            this.getBulletEntry(PROJECT_SECTIONS.LABELISED, "plus", false, false),
          )
        }

        labeliseMenuEntry.children.push(
          this.getBulletEntry(PROJECT_SECTIONS.LABELISED, "infos", true, false),
        )
        menuItems.push(labeliseMenuEntry)

        const possibleMenuParents = [""]
        eventBus.emit("contextual-menu-changed", new ContextMenu(possibleMenuParents, menuItems))
        this.sectionChanged()
        this.refreshActiveAnchor()
      }
    },

    refreshActiveAnchor(): void {
      const anchorsForThisSection = this.anchorsToTrack.get(this.section)
      for (let i = 0; anchorsForThisSection && i < anchorsForThisSection.length; i++) {
        const anchorY = document.getElementById(anchorsForThisSection[i])?.offsetTop
        if (this.pxFromBottom <= 60) {
          eventBus.emit(
            "contextual-menu-anchor-update",
            anchorsForThisSection[anchorsForThisSection.length - 1],
          )
          return
        } else {
          if (anchorY && this.currentScrollY <= anchorY - 20) {
            eventBus.emit(
              "contextual-menu-anchor-update",
              anchorsForThisSection[Math.max(0, i - 1)],
            )
            return
          }
        }
      }
    },

    getMenuEntry(
      section: string,
      icone: string,
      subtab: string,
      useDifferentMenuTitleForAccompagnateur?: boolean,
    ): NavbarItem {
      const basePath = "/project/" + this.project.projetId + "/" + this.project.id + "/"
      let textConstantId = "projet.menu." + section
      if (useDifferentMenuTitleForAccompagnateur) {
        textConstantId += "-accompagnateur"
      }

      if (section == "labellise") {
        textConstantId += this.renewalSuffix
      }

      this.sectionsToIcon.set(section, icone)
      return new NavbarItem(
        basePath + section + "/" + subtab,
        this.$t(textConstantId).toString(),
        icone,
        false,
      )
    },

    getBulletEntry(
      section: string,
      anchor: string,
      addSuffixForPP: boolean,
      alwaysValidatioNeutral?: boolean,
    ): BulletWithValidation {
      let validationStatus = ValidationStatus.NONE
      if (this.validationActivated && this.wasValidatedAtLeastOnce && this.lastProjectValidation) {
        validationStatus = ValidationStatus.VALID
        if (this.lastProjectValidation.invalidFields.get(anchor)) {
          validationStatus = ValidationStatus.ERROR
        } else if (this.lastProjectValidation.emptyFields.get(anchor)) {
          validationStatus = ValidationStatus.WARNING
        }
      }
      // For the 'finalisation section': get the worse status
      if (anchor == "presentation") {
        if (this.lastProjectValidation.invalidFields.size > 0) {
          validationStatus = ValidationStatus.ERROR
        } else if (this.lastProjectValidation.emptyFields.size > 0) {
          validationStatus = ValidationStatus.WARNING
        }
      }

      if (alwaysValidatioNeutral) {
        validationStatus = ValidationStatus.NEUTRAL
      }

      let anchorsForSection = this.anchorsToTrack.get(section)
      if (!anchorsForSection) {
        anchorsForSection = []
      }
      anchorsForSection.push(anchor)
      this.anchorsToTrack.set(section, anchorsForSection)

      let itemTitle = this.$t("projet." + section + "." + anchor).toString()
      if (addSuffixForPP && this.isPorteurProjet) {
        itemTitle = this.$t("projet." + section + "." + anchor + "-pp").toString()
      }
      return new BulletWithValidation(anchor, itemTitle, validationStatus)
    },

    sectionChanged(): void {
      const anchorsForThisSection = this.anchorsToTrack.get(this.section)
      if (anchorsForThisSection) {
        eventBus.emit("contextual-menu-anchor-update", anchorsForThisSection[0])
      }

      const mapScreenShotRequestedInQueryURL: string =
        this.$route.query?.mapScreenShotRequested?.toString()
      if (mapScreenShotRequestedInQueryURL) {
        this.$nextTick(() => {
          setTimeout(() => {
            this.mapScreenShotRequested = true
          }, 1500)
        })
      }
    },

    setRenewalSuffix(): void {
      this.renewalSuffix = this.project.typeDossier === "DOSSIER_LABELLISATION" ? "" : "-renewal"
    },

    doMapScreenshot(): void {
      if (this.section != "bref") {
        this.$router.push({
          params: { section: "bref" },
          query: { mapScreenShotRequested: "true" },
        })
      } else {
        this.mapScreenShotRequested = true
      }
    },

    mapScreenshotDone(dataUrl: string | null): void {
      this.mapScreenShotRequested = false
      this.$emit("screenshot-ready", dataUrl)
    },

    updateProjetAnnuel(updatedProjetAnnuel: any): void {
      this.$emit("projet-annuel-updated", updatedProjetAnnuel)
      this.$emit("dirtify-project")
    },
  },
})
</script>

<style lang="scss">
.onlyDisplayedifSectionIsActive {
  display: none;

  &.activeSection {
    display: block;
  }
}

.projet-part {
  padding-right: 0 !important;
}

.main-content {
  .first {
    width: 100%;
  }

  .second {
    width: 100%;
  }
}

@media screen and (min-width: 1064px) {
  .main-content {
    display: flex !important;
    justify-content: flex-start;

    .first {
      width: 59%;
    }

    .second {
      width: 41%;
    }
  }
}
</style>
